<template>
  <div>
    <div>
        <div v-if="!isHome && !isIOSWebView" class="fixed top-16 left-[10%] z-[100]">
          <HistoryBack/>
        </div>
    </div>
    <Header v-if="!isWebView"></Header>
    <div :class="{ 'mb-20': isMobile}">
          <slot />
    </div>
  </div>
</template>
<script lang="ts">
import HistoryBack from "@/components/form/historyBack.vue";
import Header from "@/components/header/header.vue";
import { AppsHelper } from "@/helpers/appsHelper";
import { RouteLocationNormalizedLoaded } from "vue-router";

export default {
    components: {
      Header,
      HistoryBack
    },
    computed: {
      isHome(this: { $route: RouteLocationNormalizedLoaded }): boolean {
        return this.$route.path === "/";
      },
      isWebView(): boolean {
        return AppsHelper.isWebView();
      },
      isIOSWebView(): boolean {
        return AppsHelper.isIOSWebView();
      },
      isMobile(): boolean {
        return AppsHelper.isMobile();
      }
    }
};
</script>
<style scoped>
.safe-bottom {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>